import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import ConfirmPopUpMobilization from "./ConfirmPopUp/ConfirmPopUpMobilization";
import ProjectDropDown from "../../../../ReusableComponents/ProjectDropDown/ProjectDropDown";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { getProjectData } from "../../../../store/Api";
import MobilizationConfrimPopUp from "./MobilizationConfirmPopUp";

export default function MobilizationFormPopUp({
  PopUp,
  setPopUp,
  url,
  callBack,
  listData = [],
}) {
  console.log("props Data to be seen here", listData);
  const [yesPopup, setYesPopup] = useState(false);

  const [backUP, SetBackUp] = useState();

  const Project = useSelector((state) => state.projectData);
  const [jobPositions, setJobPositions] = useState([]);

  const [existingClient, setExistingClient] = useState();
  const [isChanged, setIsChanged] = useState(false);
  const [formData, setFormData] = useState({
    mobilizationDate: " ",
    serviceCharge: " ",
    Employeelocation: "",
    contractType: " ",
    clientName: " ",
    mobileAllowance: " ",
    actualProfession: " ",
    airTicketAllowance: " ",
    basic: " ",
    additionalOt: " ",
    food: " ",
    otherAllowance: " ",
    fixedOt: " ",
    dutyHours: " ",
    hra: " ",
    fixedOtHours: " ",
    travelAllowance: " ",
    airTicketAllowance: "",
  });

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [projectId, setProjectId] = useState();

  function getDaysBetweenDates(date1, date2) {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = secondDate - firstDate;

    // Convert milliseconds to days
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    return differenceInDays;
  }

  const submitHandler = async (e) => {
    debugger
    if (
      formData.mobilizationDate === null ||
      formData.mobilizationDate === undefined ||
      formData.mobilizationDate === " "
    ) {
      dispatch(
        setAppError({
          msg: "Mobilization Date is required....",
        })
      );
      return;
    }
    let NewArray = [];
    let IdleAging = getDaysBetweenDates(
      listData.arrival_date,
      formData.mobilizationDate
    );
    console.log(".......IdleAging......", IdleAging);
    NewArray.push({
      employee_contract_start_Date: listData.arrival_date,
      project_id: backUP.projectId,
      employee_id: listData.candidate_id,
      Idleagaging: backUP.projectId != formData.newProject_id ? IdleAging : 0,
      employee_contract_end_Date:
        backUP.projectId != formData.newProject_id
          ? formData.mobilizationDate
          : null,
      Totalsalary:
        parseInt(formData.otherAllowance) +
        parseInt(formData.additionalOt) +
        parseInt(formData.airTicketAllowance) +
        parseInt(formData.mobileAllowance) +
        parseInt(formData.travelAllowance) +
        parseInt(formData.hra) +
        parseInt(formData.fixedOt) +
        parseInt(formData.food) +
        parseInt(formData.basic) +
        parseInt(formData.serviceCharge),
      Basicsalary: formData.basic,
    });
    if (backUP.projectId != formData.newProject_id) {
      NewArray.push({
        employee_contract_start_Date: formData.mobilizationDate,
        project_id: formData.newProject_id,
        employee_id: listData.candidate_id,
        Totalsalary:
          parseInt(formData.otherAllowance) +
          parseInt(formData.additionalOt) +
          parseInt(formData.airTicketAllowance) +
          parseInt(formData.mobileAllowance) +
          parseInt(formData.travelAllowance) +
          parseInt(formData.hra) +
          parseInt(formData.fixedOt) +
          parseInt(formData.food) +
          parseInt(formData.basic) +
          parseInt(formData.serviceCharge),
        Basicsalary: formData.basic,
      });
    }
    var type = {
      employee_id: listData.candidate_id,
      mobilization_date: formData.mobilizationDate,
      project_id: formData.newProject_id,
      service_charge: formData.serviceCharge,
      contract_type: formData.contractType,
      client: formData.clientName,
      client_id: formData.client_id,
      Idleagaging: IdleAging ,
      actual_profession: formData.actualProfession,
      Totalsalary:
        parseInt(formData.otherAllowance) +
        parseInt(formData.additionalOt) +
        parseInt(formData.airTicketAllowance) +
        parseInt(formData.mobileAllowance) +
        parseInt(formData.travelAllowance) +
        parseInt(formData.hra) +
        parseInt(formData.fixedOt) +
        parseInt(formData.food) +
        parseInt(formData.basic) +
        parseInt(formData.serviceCharge),
      Basicsalary: formData.basic,
      basic: formData.basic,
      food: formData.food,
      fixed_ot: formData.fixedOt,
      hra: formData.hra,
      travel_allowance: formData.travelAllowance,
      mobile_allowance: formData.mobileAllowance,
      air_ticket_allowance: formData.airTicketAllowance,
      additional_ot: formData.additionalOt,
      other_allowance: formData.otherAllowance,
      duty_hours: formData.dutyHours,
      fixed_ot_hours: formData.fixedOtHours,
      client_id: formData.client_id,
      sector_id: formData.sector_id,
      sponsor_id: formData.sponsor_id,
      company_id: formData.company_id,
      existingClient: existingClient,
      existingData: backUP,
      valueChanged: backUP.projectId != formData.newProject_id ? true : false,
      Journey: NewArray,
      Employeelocation: formData.Employeelocation,
    };
    console.log("type...........type....type", type);
    setLoading(true);
    try {
      const response = await nodeinstance.post(
        `/mobilization/employeeMobilization`,
        type,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setLoading(false);
        setPopUp(false);
        setYesPopup(false);
        callBack(); // This will refresh the list
      } else {
        dispatch(
          setAppError({
            msg: response.data.message,
          })
        );
        setLoading(false);
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
    }
  };
  const laravelToken = localStorage.getItem("token");
  useEffect(() => {
    getDetailsAutoFill();
    dispatch(getProjectData(laravelToken));
    fetchJobPositions();
  }, []);

  const fetchJobPositions = async () => {
    try {
      const response = await nodeinstance.get('/mobilization/getAllJobPositions', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.status === 200) {
        setJobPositions(response.data.data || []);
      }
    } catch (error) {
      console.log("Error fetching job positions:", error);
    }
  };

  const token = localStorage.getItem("nodeToken");
  const getProjectsId = async (e) => {
    const id = e.target.value;

    console.log(id, listData, "Project id to be shown here in console");
    // setProjectId(id);
    const reqObject = {
      id: id,
    };
    if (id != listData.project_id) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
    try {
      const response = await nodeinstance.post(
        `mobilization/getDetailsByProject`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data) {
          var setData = response?.data?.data[0];
          console.log(setData, "........................................");
          setFormData({
            ...formData,
            projectId: setData.project_id,
            contractType: setData.quotation_type,
            clientName: setData.client,
            client_id: setData.client_id,
            sector_id: setData.sector_id,
            sponsor_id: setData.sponsor_id,
            company_id: setData.company_id,
            newProject_id: setData.projectId,
            actualProfession: setData.actual_profession_id ? setData.actual_profession_id.toString() : "",
          });
        }
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.response?.message,
        })
      );
      setLoading(false);
      console.log("error", err);
    }
  };

  const getDetailsAutoFill = async () => {
    try {
      const response = await nodeinstance.get(
        `mobilization/getEmpData/${listData.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        var setData = response.data.data[0];
        console.log("my data....mmamamamamma", setData);

        setFormData({
          ...formData,
          serviceCharge: setData.service_charge,
          contractType: setData.quotation_type,
          client_id : setData.client_id_invoice,
          clientName: setData.client,
          mobileAllowance: setData.mobile_allowance,
          actualProfession: setData.job_position_id ? setData.job_position_id.toString() : "",
          airTicketAllowance: setData.air_ticket_allowance,
          basic: setData.basic,
          additionalOt: setData.additional_ot,
          food: setData.food,
          otherAllowance: setData.other_allowance,
          fixedOt: setData.fixed_ot,
          dutyHours: setData.duty_hours,
          hra: setData.hra,
          fixedOtHours: setData.fixed_ot_hours,
          travelAllowance: setData.travel_allowance,
          projectId: setData.project_id,
          newProject_id: setData.projectId,
          Employeelocation: setData.Sector_Name,
        });
        setProjectId(setData.project_id);
        setExistingClient(setData.client_id_invoice);
        SetBackUp(setData);
        console.log("id", projectId);
      } else {
        dispatch(
          setAppError({
            msg: response.data.message,
          })
        );
        setLoading(false);
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
    }
  };
  console.log(formData);

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-xl w-full max-h-[40rem] min-h-[15rem] overflow-y-scroll overflow-x-hidden rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div
            className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800"
            style={{ margin: 2 }}
          >
            <div className="w-full max-w-7xl mx-auto">
              {/* Form Header */}
              <div className="mb-6">
                <h2 className="text-xl font-bold text-gray-800 dark:text-white">Employee Mobilization Details</h2>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Fill in all required information below</p>
              </div>

              {/* Form Grid - Professional 2 Column Layout */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">

                {/* Mobilization Date */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Mobilization Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="Date"
                    value={formData.mobilizationDate}
                    min={
                      listData?.arrival_date
                        ? new Date(listData.arrival_date).toISOString().split("T")[0]
                        : ""
                    }
                    max={new Date().toISOString().split("T")[0]}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mobilizationDate: e.target.value,
                      })
                    }
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>

                {/* Service Charge */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Service Charge <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.serviceCharge}
                    placeholder="Enter service charge"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        serviceCharge: value,
                      });
                      setIsChanged(value !== formData.serviceCharge);
                    }}
                  />
                </div>

                {/* Contract Type */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Contract Type
                  </label>
                  <input
                    value={formData.contractType}
                    placeholder="Auto-populated"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-600 text-gray-600 dark:text-gray-400 text-sm cursor-not-allowed"
                    disabled
                  />
                </div>

                {/* Project Name - Full Width */}
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Project Name <span className="text-red-500">*</span>
                  </label>
                  <select
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    onChange={getProjectsId}
                    value={formData.projectId}
                  >
                    <option value="">Select Project</option>
                    {Project?.data?.map((data, index) => (
                      <option key={index} value={data.project_id}>{data.name}</option>
                    ))}
                  </select>
                </div>

                {/* Client Name - Full Width */}
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Client Name
                  </label>
                  <input
                    value={formData.clientName}
                    placeholder="Auto-populated"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-600 text-gray-600 dark:text-gray-400 text-sm cursor-not-allowed"
                    disabled
                  />
                </div>

                {/* Actual Profession - Full Width */}
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Actual Profession <span className="text-red-500">*</span>
                  </label>
                  <select
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    value={formData.actualProfession}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        actualProfession: value,
                      });
                      setIsChanged(value !== (backUP?.job_position_id ? backUP.job_position_id.toString() : ""));
                    }}
                  >
                    <option value="">Select Profession</option>
                    {jobPositions.map((position, index) => (
                      <option key={index} value={position.id.toString()}>
                        {position.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Basic Salary */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Basic Salary <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.basic}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        basic: e.target.value,
                      });
                      setIsChanged(value !== formData.basic);
                    }}
                  />
                </div>

                {/* Food Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Food Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.food}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        food: e.target.value,
                      });
                      setIsChanged(value !== formData.food);
                    }}
                  />
                </div>

                {/* HRA */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    HRA <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.hra}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        hra: e.target.value,
                      });
                      setIsChanged(value !== formData.hra);
                    }}
                  />
                </div>

                {/* Fixed OT */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Fixed OT <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.fixedOt}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        fixedOt: e.target.value,
                      });
                      setIsChanged(value !== formData.fixedOt);
                    }}
                  />
                </div>

                {/* Mobile Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Mobile Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.mobileAllowance}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        mobileAllowance: e.target.value,
                      });
                      setIsChanged(value !== formData.mobileAllowance);
                    }}
                  />
                </div>

                {/* Travel Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Travel Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.travelAllowance}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        travelAllowance: e.target.value,
                      });
                      setIsChanged(value !== formData.travelAllowance);
                    }}
                  />
                </div>

                {/* Air Ticket Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Air Ticket Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.airTicketAllowance}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        airTicketAllowance: e.target.value,
                      });
                      setIsChanged(value !== formData.airTicketAllowance);
                    }}
                  />
                </div>

                {/* Additional OT */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Additional OT <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.additionalOt}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        additionalOt: e.target.value,
                      });
                      setIsChanged(value !== formData.additionalOt);
                    }}
                  />
                </div>

                {/* Other Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Other Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.otherAllowance}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        otherAllowance: e.target.value,
                      });
                      setIsChanged(value !== formData.otherAllowance);
                    }}
                  />
                </div>

                {/* Duty Hours */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Duty Hours <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.dutyHours}
                    placeholder="Enter hours"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        dutyHours: e.target.value,
                      });
                      setIsChanged(value !== formData.dutyHours);
                    }}
                  />
                </div>

                {/* Fixed OT Hours */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Fixed OT Hours <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.fixedOtHours}
                    placeholder="Enter hours"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        fixedOtHours: e.target.value,
                      });
                      setIsChanged(value !== formData.fixedOtHours);
                    }}
                  />
                </div>

                {/* Employee Location */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Employee Location <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.Employeelocation}
                    placeholder="Enter location"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        Employeelocation: e.target.value,
                      });
                    }}
                  />
                </div>

              </div>

              {/* Action Buttons Section */}
              <div className="mt-8 flex justify-center gap-4">
                {/* Cancel Button */}
                <button
                  type="button"
                  className="inline-flex items-center px-6 py-2.5 bg-btn-dark text-white font-semibold text-xs uppercase rounded-lg hover:bg-btn-dark-hover focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-all duration-150 shadow-md hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98]"
                  onClick={() => window.history.back()}
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Cancel
                </button>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="inline-flex items-center px-6 py-2.5 bg-btn-red text-white font-semibold text-xs uppercase rounded-lg hover:bg-btn-red-hover focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-150 shadow-md hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => setYesPopup(true)}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <CgSpinner className="w-4 h-4 mr-2 animate-spin" />
                      Submitting...
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      Submit Mobilization
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {yesPopup ? (
        <MobilizationConfrimPopUp
          PopUp={yesPopup}
          setYesPopup={setYesPopup}
          title={"ARE YOU SURE YOU WANT TO PROCEED WITH THESE CHANGES"}
          callBack={submitHandler}
        />
      ) : (
        ""
      )}
    </>
  );
}
